import * as React from "react";
import { Button, Box, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { CloseOutlined } from "@ant-design/icons";
import { useTheme } from "@mui/material/styles";

const saveButtonType = Object.freeze({
    SAVE: "SAVE",
});
export const ToggleStateButton = ({ state, states, ...props }) => {
    const statesLength = states.length;
    const [position, setPosition] = React.useState(0);
    const currentState = states[position];

    React.useEffect(() => {
        if (state < statesLength) setPosition(state);
    }, [state]);

    const handleClick = () => {
        currentState.onClick(position);
    };
    return (
        <>
            <Button size="small" {...currentState} onClick={handleClick} />
        </>
    );
};

const CreateComponent = (
    { component, props = {} },
    defaults = { component: null, props: {} }
) => {
    return {
        component: component ?? defaults.component,
        props: { ...defaults.props, ...props },
    };
};

export const DialogActions = ({ children }) => {
    return <>{children}</>;
};
export default function FullScreenDialog({
    children,
    toolbarChildren,
    title,
    open,
    onClose,
    actions,
    maxWidth = "lg",
    toolbar,
}) {
    const theme = useTheme();

    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <AppBar
                position="sticky"
                sx={{
                    boxShadow: "none",
                    borderBottom: `1px solid ${theme.palette.grey.A800}`,
                }}
                color="inherit"
            >
                {!toolbar ? (
                    <Toolbar>
                        <Box>
                            <Stack
                                direction={{ xs: "row", sm: "row" }}
                                alignItems={{ xs: "center" }}
                                justifyContent={"space-between"}
                                spacing={1}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        onClick={onClose}
                                        aria-label="close"
                                    >
                                        <CloseOutlined />
                                    </IconButton>
                                    <Typography variant="h6" component="div">
                                        {title}
                                    </Typography>
                                </Box>
                                {!!toolbarChildren && toolbarChildren}
                            </Stack>
                        </Box>
                    </Toolbar>
                ) : (
                    toolbar
                )}
            </AppBar>
            <Box
                sx={{
                    width: "100%",
                    maxWidth: maxWidth,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignSelf: "center",
                    flexGrow: 1,
                    p: { xs: 2, sm: 3 },
                }}
            >
                {children}
                <Stack
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "20px 0",
                    }}
                    direction="row"
                    spacing={3}
                >
                    {actions}
                </Stack>
            </Box>
        </Dialog>
    );
}
